import React, { useState, useEffect } from "react";

import LiveAttendance from "./LiveAttendance";
import DailyAttendance from "./DailyAttendance";
import AttendanceDashboard from "./AttendanceDashboard";
import MonthlyAttendance from "./MonthlyAttendance";
import MonthlyAttendanceReport from "./MonthlyAttendanceReport";

import { HasPermission } from "../../services/hasPermission";
import Widgets from "../../components/Widgets";

const Attendance = () => {
  const [activeTab, setActiveTab] = useState("");

  const attendanceTab = [
    {
      name: "Live Attendance",
      path: "live",
      isAccess: HasPermission("Live Attendance", "view"),
    },
    {
      name: "Daily Attendance",
      path: "daily",
      isAccess: HasPermission("Daily Attendance", "view"),
    },
    // { name: "Attendance Dashboard", path: "dashboard", isAccess: HasPermission("Attendance Dashboard", "view") },
    {
      name: "Monthly Attendance",
      path: "monthly",
      isAccess: HasPermission("Monthly Attendance", "view"),
    },
  ];

  // ✅ Set first permitted tab on mount & strip any hash from URL
  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
    const firstAccessible = attendanceTab.find((item) => item.isAccess === true);
    if (firstAccessible) {
      setActiveTab(firstAccessible.path);
    }
  }, []);

  const handleTab = (path) => {
    setActiveTab(path);
  };

  return (
    <div
      style={{
        position: "fixed",
        width: "calc(100vw)",
        height: "calc(100vh - 80px)",
      }}
    >
      <Widgets
        icon={
          <div
            style={{
              zIndex: "0",
              marginTop: "-12px",
              borderRadius: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "20px",
            }}
          >
            {attendanceTab.map((item, idx) => {
              return (
                item.isAccess && (
                  <span
                    onClick={() => handleTab(item.path)}
                    style={{ textDecoration: "none", cursor: "pointer" }}
                    key={idx}
                    className={
                      activeTab === item.path ||
                        (activeTab === "report" && item.path === "monthly")
                        ? `color-white payroll-tab active`
                        : `color-white payroll-tab`
                    }
                  >
                    {item.name}
                  </span>
                )
              );
            })}
          </div>
        }
        body={
          <>
            {activeTab == "live" && <LiveAttendance />}
            {activeTab == "daily" && <DailyAttendance />}
            {activeTab == "dashboard" && <AttendanceDashboard />}
            {activeTab == "monthly" && <MonthlyAttendance />}
            {activeTab == "report" && <MonthlyAttendanceReport />}
          </>
        }
      />
    </div>
  );
};

export default Attendance;